import ColTwo from "../../components/FlexView/ColTwo";
import FlexViewTwo from "../../components/FlexView/FlexViewTwo/FlexViewTwo";
import BorderLeftBox from "../../components/boxes/BorderLeftBox";
import HightlightCardUnactive from "../../components/cards/HightlightCardUnactive";
import TextAndImageSection from "../../components/sections/TextAndImageSection";
import SingleTabFour from "../../components/tabs/TabsViewFour/SingleTabFour";
import TabsViewFour from "../../components/tabs/TabsViewFour/TabsViewFour";
import ourJourneyPageDataAr from "../../data/arabic/our-journey-page-data-ar";
import Footer from "../../layouts/Footer";
import MainHeader from "../../layouts/MainHeader";

const JourneyPageAr = () => {
    return (
        <main id="main" className="page">
            <div className="sticky-view">
                <div className="sticky-container">
                    <MainHeader 
                        image={{
                            src : require(`../../assets/images/wallpaper/${ourJourneyPageDataAr.header.image.name}`),
                            alt : "Our esg journy background",
                        }}
                        title={ourJourneyPageDataAr.mainTitle}
                    />
                </div>
                <div className="sticky-container-two" id="mainContent">
                    
                    <div className="wrapper-small">
                        <BorderLeftBox 
                            title={ourJourneyPageDataAr.sectionOne.borderBox.title}
                            subtitle={ourJourneyPageDataAr.sectionOne.borderBox.subtitle}
                        />
                        
                    </div>
                    <div className="translate-bottom-1">
                        <div className="wrapper-small">
                            <FlexViewTwo>
                            {
                            ourJourneyPageDataAr.sectionOne.cards.map((item, index) => (
                                <ColTwo key={index}>
                                    <HightlightCardUnactive 
                                        title={item.title}
                                    />
                                </ColTwo>
                            ))
                            }
                            </FlexViewTwo>
                        </div>
                    </div>
                    <div className="dark-section">
                        <div className="space-50"></div>
                        <div className="space-50"></div>
                        <div className="space-50"></div>
                    </div>
                    <div className="translate-top-2">
                        <div className="wrapper-larg">
                            <TextAndImageSection 
                                title=""
                                image={{
                                    src : require('../../assets/images/sections/journey.jpg'),
                                    alt : "Mils over field"
                                }}
                                height="500px"
                            />
                        </div>
                    </div>
                    <div className="wrapper-larg">
                        <div className="space-50"></div>
                        <div className="space-50"></div>
                        <div className="space-50"></div>
                        <div className="wrapper-x-small">
                            <h2 className="title-center">{ourJourneyPageDataAr.timeLine.title}</h2>
                        </div>
                        <TabsViewFour
                            headers={ourJourneyPageDataAr.timeLine.headers}
                            type="two"
                        >
                            {
                            ourJourneyPageDataAr.timeLine.tabs.map((item, index) => (
                                <SingleTabFour
                                    key={index}
                                    title={item.title}
                                    subtitle={item.subtitle}
                                    list={item.list}
                                    image={item.image}
                                />
                            ))
                            }
                        </TabsViewFour>
                        <div className="space-50"></div>
                        <div className="space-50"></div>
                        <div className="space-50"></div>
                    </div>
                    <Footer withBlogs={false} />
                </div>
            </div>
        </main>
    )
}

export default JourneyPageAr;